<p-dialog
  header="Allocate Depot"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  (onShow)="onShow()"
  [style]="{ width: '400px' }"
>
  <ng-container *ngIf="!loading; else loadingContent">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-grid-row">
        <div class="ui-g-4"><label>Depot</label></div>
        <div class="ui-g-8">
          <p-dropdown
            name="dialogDepots"
            [options]="supplierDepots"
            [(ngModel)]="selectedDepotId"
            appendTo="body"
            placeholder="Select depot"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row" style="float: right">
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="allocateDepot()"
        label="Allocate"
        [disabled]="!selectedDepotId"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="visibleChange.emit(false)"
      ></button>
    </div>
  </ng-container>
</p-dialog>

<ng-template #loadingContent>
  <div
    class="flex align-items-center justify-content-center w-full"
    style="height: 270px; font-size: 25px"
  >
    <i class="fa fa-spin fa-spinner"></i>
  </div>
</ng-template>
